<template>
  <v-progress-circular
    :value="value"
    :color="color"
    :indeterminate="indeterminate"
    :rotate="rotate"
    :size="size"
    :width="width"
  ></v-progress-circular>
</template>

<script>
/**
 * Comopentes utilizado primariamente para indicar um estado de loading ou progresso.
 *
 * @displayName Circular Progress
 */
export default {
  name: 'ZCircularProgress',
  props: {
    /**
     * Valor do componente
     */
    value: {
      type: [Number, String],
      required: true,
    },
    /**
     * Define a cor da progress bar
     */
    color: {
      type: String,
      required: false,
    },
    /**
     * Aplica animação de loading no componente
     */
    indeterminate: {
      type: Boolean,
      required: false,
    },
    /**
     * Medida em graus que determina de onde a progress bar inicia
     */
    rotate: {
      type: [Number, String],
      required: false,
    },
    /**
     * Define o tomanho do componente
     */
    size: {
      type: [Number, String],
      required: false,
    },
    /**
     * Determina a largura da progress bar
     */
    width: {
      type: [Number, String],
      required: false,
    },
  },
}
</script>

<style></style>
